import { requests } from './api'

const getGlobalSearch = ({ params }) =>
  requests.get({ url: `search`, params }).then((res) => res.data)

export default {
  getGlobalSearch,
}
